import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_TICKETS } from "../../../utils/constants";
import { TicketInterface } from "../../../models/TicketModule/Ticket";
import ticketService from "../../../services/ticketService/ticketService";

type UpdateVars = {
  ticketId: string;
  newStatusId: string;
  newStatus?: any; // replace with your StatusInterface if you have it
};

interface Ctx {
  snapshots: Array<[readonly unknown[], TicketInterface[] | undefined]>;
}

const useUpdateKanbanStatus = () => {
  const queryClient = useQueryClient();

  return useMutation<TicketInterface, Error, UpdateVars, Ctx>({
    mutationFn: async ({ ticketId, newStatusId }) => {
      return ticketService.UpdateStatus(ticketId, newStatusId);
    },

    onMutate: async ({ ticketId, newStatusId, newStatus }) => {
      await queryClient.cancelQueries({ queryKey: [CACHE_KEY_TICKETS] });

      const snapshots = queryClient.getQueriesData<TicketInterface[]>({
        queryKey: [CACHE_KEY_TICKETS],
      });

      snapshots.forEach(([key, old]) => {
        if (!old) return;

        queryClient.setQueryData<TicketInterface[]>(key, (prev) => {
          if (!prev) return prev;

          return prev.map((t) =>
            t.id === ticketId
              ? {
                  ...t,
                  statusId: newStatusId,
                  ...(newStatus !== undefined ? { status: newStatus } : {}),
                }
              : t
          );
        });
      });

      return { snapshots };
    },

    onError: (_err, _vars, ctx) => {
      ctx?.snapshots.forEach(([key, data]) => {
        queryClient.setQueryData(key, data);
      });
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [CACHE_KEY_TICKETS] });
    },
  });
};

export default useUpdateKanbanStatus;
